import PropTypes from 'prop-types'
import { createContext, useState, useEffect, useRef } from 'react'
import * as menusService from '../servicios/menusService'

export const MenuContext = createContext()
MenuContext.displayName = 'MenuContext'

export const MenuProvider = (props) => {
  const [menus, setMenus] = useState([])
  const [menuAbierto, desplegarMenu] = useState(false)
  const nav = useRef(null)

  useEffect(() => {
    const obtenerMenus = async () => {
      try {
        const { data: menus } = await menusService.buscarTodos()
        setMenus(menus)
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error al obtener menús:', error)
        // Set empty array as fallback
        setMenus([])
      }
    }

    obtenerMenus()
  }, [])

  useEffect(() => {
    if (nav.current) {
      // Toggle the minify class based on menu state
      if (menuAbierto) {
        nav.current.classList.remove('vertical_nav__minify')
      } else {
        nav.current.classList.add('vertical_nav__minify')
      }
    }
  }, [menuAbierto])

  return (
    <MenuContext.Provider value={{ menus, desplegarMenu, menuAbierto, nav }}>
      {props.children}
    </MenuContext.Provider>
  )
}

MenuProvider.propTypes = {
  children: PropTypes.node.isRequired
}
